export default __webpack_public_path__ + "static/media/logo-vc.8449a5eb.png";